export const DOCUMENT_DOWNLOAD = "/api/pa/files/static/download"
export const DOCUMENT_UPLOAD = "/api/pa/files/static/upload"
